<script>
export default {
    props: ['image', 'title', 'desc', 'position', 'type'],
    name: "banner",
    data() {
        return {};
    },
    computed: {},
    components: {
        
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {},
};
</script>

<template>
    <div class="banner" :class="type">
        <div class="layout_bg bg" :style="`background-image: url(${image});`"></div>
        <div class="wrapper layout_main">
            <div class="content flex flex_column" :class="position">
                <p class="title" v-if="title" v-html="$textToHtml(title)"></p>
                <p class="desc" v-if="desc" v-html="$textToHtml(desc)"></p>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.banner{
    height: 6.3rem;
    position: relative;
    color: #fff;
    @media only screen and (max-width: 750px) {
        height: 4.6rem;
    }
    .bg{
        position: absolute;
        top: 0;
        left: 0;
    }
    &.home{
        .title{
            font-size: .9rem;
            @media only screen and (max-width: 750px) {
                font-size: .6rem;
            }
        }
    }
    .title{
        font-size: .8rem;
        font-weight: bold;
        @media only screen and (max-width: 750px) {
            font-size: .48rem;
        }
    }
    .desc{
        font-size: .24rem;
        line-height: 1.8;
    }
    .wrapper{
        position: relative;
        height: 100%;
        .content{
            position: absolute;
            gap: .2rem;
            left: 0;
            top: 0;
            @media only screen and (max-width: 750px) {
                gap: .1rem;
            }
            &.top{
                bottom: auto;
                top: 1.2rem;
                @media only screen and (max-width: 750px) {
                    top: .5rem;
                }
            }
            &.bottom{
                top: auto;
                bottom: 1.2rem;
                @media only screen and (max-width: 750px) {
                    bottom: .5rem;
                }
            }
            &.left{
                right: auto;
                left: 1rem;
                @media only screen and (max-width: 750px) {
                    left: 0;
                }
            }
            &.right{
                left: auto;
                right: 1rem;
                text-align: right;
                @media only screen and (max-width: 750px) {
                    right: 0;
                }
            }
            &.center{
                top: 50%;
                transform: translate(0, -50%);
            }
        }
    }
}
</style>